import { TextFieldRoot, TextFieldLabel } from "@/components/shadcn/textfield";

import {
  Combobox,
	ComboboxContent,
	ComboboxInput,
	ComboboxItem,
	ComboboxTrigger,
} from "@/components/shadcn/combobox";
import { createEffect, createSignal } from "solid-js";
import { cn } from "@/libs/cn";
import { request } from "@/requests/request";

export function ComboBoxInput(props) {

  const [text, setText] = createSignal('');
  const [options, setOptions] = createSignal([]);
  const [search, setSearch] = createSignal('');
  const [open, setOpen] = createSignal(false);

  const onInput = (item) => {
    if (!item) {
      return;
    }

    const type = props.selection === 'full' ? 'full' : 'value';
    setText(item.text);
    if (type === 'full') {
      props.input(props.name, item);
      return;
    }

    props.input(props.name, item.value);
  }

  const refresh = async () => {
    setOpen(false);
    const form = {
      search: search(),
    };

    const config = props.datasource.config;

    const params = config.params ?? [];
    const keys = Object.keys(params);

    keys.forEach(key => {
      form[key] = params[key];
    });

    try {
      const response = await request(config.url, form);

      if (response.success == false) {
        setOptions([]);
        return;
      }

      setOptions([]);
      setOptions(response.list);
    } catch (err) {
      setOptions([]);
    } finally {
      if (options().length > 0) {
        setOpen(true);
      }
    }
  }

  createEffect(() => {
    props.datasource;

    if (props.datasource?.type === 'local') {
      setOptions(
        props.datasource.data.map((item) => {
          return {
            value: item[props.datasource.value],
            text: item[props.datasource.text],
            disabled: item[props.datasource.disabled]
          };
        })
      );
    }

    if (props.datasource?.type !== 'remote') {
      return;
    }

    if (props.datasource?.default === undefined) {
      refresh();
      return;
    }

    setOptions(
      props.datasource?.default?.map((item) => {
        return {
          value: item[props.datasource.value],
          text: item[props.datasource.text],
          disabled: item[props.datasource.disabled]
        };
      })
    );

    const v = value();
    if (v) {
      const it = props.datasource?.default?.find((item) => { 
        return item[props.datasource.value] === v; 
      });

      if (!it) {
        return;
      }

      setText(it[props.datasource.text]);
    }
  });

  const value = () => {
    if (props.selection !== 'full') {
      return props.form[props.name];
    }

    return props.form[props.name]?.value;
  }

  const onDefaultFilter = () => {
    if (props.datasource.type === 'local') {
      return 'startsWith';
    }

    return true;
  }

  return (
    <TextFieldRoot class={cn("space-y-0", props.class)}>
      <TextFieldLabel class={props.sr ? 'sr-only mb-1' : ''}>{props.label}</TextFieldLabel>
      <Combobox
        onInputChange={(keyword) => { setSearch(keyword); refresh(); }}
        class={props.inputClass}
        value={{ value: value(), text: text(), disabled: false }}
        defaultFilter={onDefaultFilter}
        triggerMode="input"
        closeOnSelection={true}
        optionValue="value"
        optionTextValue="value"
        optionLabel="text"
			  optionDisabled="disabled"
        onChange={onInput}
        options={options()}
        itemComponent={(innerProps) => (
          <ComboboxItem item={innerProps.item} class="text-xs">{innerProps.item.rawValue.text}</ComboboxItem>
        )}
      >
        <ComboboxTrigger>
          <ComboboxInput class="text-sm" />
        </ComboboxTrigger>
        <ComboboxContent />
      </Combobox>
    </TextFieldRoot>
  );
}
